<ng-container *transloco="let t">
    <div class="d-flex justify-content-start align-items-center">
        <app-avatar size="lg" color="grey">
            <i [class]="isTeam ? 'bi bi-people' : 'bi bi-person'"></i>
        </app-avatar>

        <div class="ms-2">
            <div class="fs-11 color-slate-500">
                {{t(isTeam ? 'app.common.team' : 'app.common.competitor')}}
            </div>
            <div class="fs-16">
                {{
                (competitor
                        ? (isTeam ? (competitor.lastName ?? '') : ((competitor.firstName ?? '') + ' ' + (competitor.lastName ?? '')))
                        : (name ?? '')
                ) || '-' | uppercase
                }}
            </div>
            <span class="tag mint bold">
                BIB : {{(competitor ? competitor.startNumber : bib) ?? '-'}}
        </span>
        </div>
    </div>
</ng-container>